/* @bs-owned — bs-blumi.js · interações do template bs-blumi (galeria, cartões de oferta com configurador,
   parcelas por cartão, guia de tamanho, trilhos e vídeos). A compra em si é do motor compartilhado bs-buy.js. */
(function () {
  'use strict';

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function money(cents) {
    return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function headerOffset() {
    var v = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
    return (isNaN(v) ? 80 : v) + 16;
  }
  function scrollToEl(el) {
    var y = el.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    window.scrollTo({ top: y, behavior: reduced ? 'auto' : 'smooth' });
  }

  /* ---------- Galeria ---------- */
  function initGallery(g) {
    if (g.__bsb) return; g.__bsb = true;
    var track = $('[data-bsb-track]', g), slides = $$('[data-bsb-slide]', g), thumbs = $$('[data-bsb-thumb]', g);
    var count = $('[data-bsb-count]', g), prev = $('[data-bsb-prev]', g), next = $('[data-bsb-next]', g);
    // Fotos de uma cor que ficam fora do limite da galeria (data-bsb-extra) só aparecem quando a cliente escolhe a cor.
    var allSlides = slides, allThumbs = thumbs;
    slides = slides.filter(function (s) { return !s.hasAttribute('data-bsb-extra'); });
    thumbs = thumbs.filter(function (t) { return !t.hasAttribute('data-bsb-extra'); });
    if (!track || !slides.length) return;
    var idx = 0;
    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: reduced ? 'auto' : 'smooth' });
    }
    function sync() {
      var w = slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : track.clientWidth;
      var i = Math.round(track.scrollLeft / (w || 1));
      if (i === idx && count.textContent) { /* sem mudança */ }
      idx = Math.max(0, Math.min(slides.length - 1, i));
      if (count) count.textContent = (idx + 1) + ' / ' + slides.length;
      thumbs.forEach(function (t, n) {
        var on = n === idx;
        if (on) { t.setAttribute('aria-current', 'true'); } else { t.removeAttribute('aria-current'); }
        if (on && t.parentNode.scrollWidth > t.parentNode.clientWidth) {
          var p = t.parentNode, l = t.offsetLeft - p.offsetLeft;
          if (l < p.scrollLeft || l + t.offsetWidth > p.scrollLeft + p.clientWidth) p.scrollTo({ left: l - p.clientWidth / 2 + t.offsetWidth / 2 });
        }
      });
      if (prev) prev.disabled = idx === 0;
      if (next) next.disabled = idx === slides.length - 1;
    }
    var raf = 0;
    track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); }, { passive: true });
    allThumbs.forEach(function (t) { t.addEventListener('click', function () { go(+t.getAttribute('data-bsb-thumb')); }); });
    if (prev) prev.addEventListener('click', function () { go(idx - 1); });
    if (next) next.addEventListener('click', function () { go(idx + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1); }
    });
    g.__bsbGo = go;

    // Reordena as fotos (troca de cor, seção: color_photos): as posições em `first` vêm antes, o resto segue a ordem original.
    if (g.hasAttribute('data-bsb-color-photos')) {
      var pos = function (el) { return el.getAttribute('data-bsb-pos'); };
      var base = slides.map(pos), known = allSlides.map(pos);
      g.__bsbOrder = function (first) {
        var want = [];
        (first || []).concat(base).forEach(function (p) { p = String(p); if (known.indexOf(p) > -1 && want.indexOf(p) === -1) want.push(p); });
        // As escondidas vão para o fim da lista: no computador a grade só mostra as 5 primeiras (nth-child no CSS).
        var pick = function (list, box) {
          var m = {};
          list.forEach(function (el) { m[pos(el)] = el; el.style.display = want.indexOf(pos(el)) > -1 ? '' : 'none'; });
          var on = want.map(function (p) { return m[p]; }).filter(Boolean);
          on.concat(list.filter(function (el) { return on.indexOf(el) === -1; })).forEach(function (el) { box.appendChild(el); });
          return on;
        };
        var tag = $('.bsb-cover-tag', g);
        slides = pick(allSlides, track);
        slides.forEach(function (s, n) {
          s.setAttribute('aria-label', 'Foto ' + (n + 1) + ' de ' + slides.length);
          var im = $('img', s);
          if (im && n < 5) im.loading = 'eager';
        });
        if (tag) slides[0].insertBefore(tag, slides[0].firstChild);
        if (thumbs.length) {
          var box = thumbs[0].parentNode;
          thumbs = pick(allThumbs, box);
          thumbs.forEach(function (t, n) { t.setAttribute('data-bsb-thumb', n); t.setAttribute('aria-label', 'Ver foto ' + (n + 1)); });
        }
        track.scrollTo({ left: 0, behavior: 'auto' });
        sync();
        g.dispatchEvent(new CustomEvent('bsb:reorder'));
      };
    }
    sync();
  }

  /* "Preto: 3, 14, 18" (uma cor por linha; posição da foto no produto, começa em 0) + capas "|Preto:9" (foto da
     variante, posição começa em 1) → { preto: ['8', '3', '14', '18'] }. Sem color_photos na seção → null. */
  function colorPhotos(g) {
    var raw = g && g.getAttribute('data-bsb-color-photos');
    if (!raw) return null;
    var map = {};
    (g.getAttribute('data-bsb-color-covers') || '').split('|').forEach(function (p) {
      var i = p.lastIndexOf(':');
      if (i > 0) map[p.slice(0, i).trim().toLowerCase()] = [String(parseInt(p.slice(i + 1), 10) - 1)];
    });
    raw.split(/\r?\n/).forEach(function (line) {
      var i = line.indexOf(':');
      if (i < 1) return;
      var k = line.slice(0, i).trim().toLowerCase();
      var list = map[k] || (map[k] = []);
      list.own = true;
      line.slice(i + 1).split(',').forEach(function (n) { n = parseInt(n, 10); if (!isNaN(n)) list.push(String(n)); });
    });
    return map;
  }

  /* ---------- Caixa de compra: cartões de oferta ---------- */
  /* Visualizador em tela cheia (mesmo da bodyp3): abre na foto tocada, desliza para os lados, setas e teclado. */
  function initLightbox(g) {
    // Só as fotos visíveis, na ordem atual (a troca de cor esconde/reordena as fotos).
    var visible = function () {
      return $$('[data-bsb-slide] img', g).filter(function (img) { return img.closest('[data-bsb-slide]').style.display !== 'none'; });
    };
    var imgs = visible();
    if (!imgs.length || typeof HTMLDialogElement === 'undefined') return;
    var dlg = null, strip, count, total = imgs.length, idx = 0, lastFocus = null;
    function ico(d) { return '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="' + d + '" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>'; }
    function big(img) {
      var src = img.currentSrc || img.getAttribute('src') || '';
      return /[?&]width=\d+/.test(src) ? src.replace(/([?&]width=)\d+/, '$11600') : src;
    }
    function build() {
      dlg = document.createElement('dialog');
      dlg.className = 'bsb-lb';
      dlg.setAttribute('aria-label', 'Fotos do produto em tela cheia');
      dlg.innerHTML = '<div class="bsb-lb__strip" tabindex="-1"></div>' +
        '<button type="button" class="bsb-lb__close" aria-label="Fechar">' + ico('M6 6l12 12M18 6L6 18') + '</button>' +
        '<button type="button" class="bsb-lb__nav bsb-lb__nav--prev" aria-label="Foto anterior">' + ico('M15 5l-7 7 7 7') + '</button>' +
        '<button type="button" class="bsb-lb__nav bsb-lb__nav--next" aria-label="Próxima foto">' + ico('M9 5l7 7-7 7') + '</button>' +
        '<p class="bsb-lb__count" aria-live="polite"></p>';
      strip = $('.bsb-lb__strip', dlg); count = $('.bsb-lb__count', dlg);
      imgs.forEach(function (img, i) {
        var fig = document.createElement('figure'); fig.className = 'bsb-lb__slide';
        var im = document.createElement('img'); im.alt = img.alt || ('Foto ' + (i + 1)); im.decoding = 'async';
        fig.appendChild(im); strip.appendChild(fig);
      });
      $('.bsb-lb__close', dlg).addEventListener('click', close);
      $('.bsb-lb__nav--prev', dlg).addEventListener('click', function () { go(idx - 1, true); });
      $('.bsb-lb__nav--next', dlg).addEventListener('click', function () { go(idx + 1, true); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg || e.target.classList.contains('bsb-lb__slide')) close(); });
      dlg.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1, true); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1, true); }
      });
      dlg.addEventListener('close', function () {
        document.documentElement.classList.remove('bsb-lb-open');
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      });
      var t = false;
      strip.addEventListener('scroll', function () {
        if (t) return; t = true;
        requestAnimationFrame(function () { t = false; idx = Math.round(strip.scrollLeft / (strip.clientWidth || 1)); paint(); });
      }, { passive: true });
      document.body.appendChild(dlg);
    }
    function load(i) {
      var im = strip.children[i] && strip.children[i].querySelector('img');
      if (im && imgs[i]) { var src = big(imgs[i]); if (im.getAttribute('src') !== src) im.src = src; }
    }
    function paint() {
      idx = Math.max(0, Math.min(total - 1, idx));
      count.textContent = (idx + 1) + ' / ' + total;
      $('.bsb-lb__nav--prev', dlg).disabled = idx === 0;
      $('.bsb-lb__nav--next', dlg).disabled = idx === total - 1;
      load(idx); load(idx + 1); load(idx - 1);
    }
    function go(i, smooth) {
      idx = Math.max(0, Math.min(total - 1, i));
      strip.scrollTo({ left: idx * strip.clientWidth, behavior: smooth && !reduced ? 'smooth' : 'auto' });
      paint();
    }
    function open(i) {
      if (!dlg) build();
      lastFocus = document.activeElement;
      document.documentElement.classList.add('bsb-lb-open');
      dlg.showModal(); go(i, false);
      strip.focus({ preventScroll: true });
    }
    function close() { if (dlg && dlg.open) dlg.close(); }
    function label() {
      imgs.forEach(function (img, i) { img.closest('[data-bsb-slide]').setAttribute('aria-label', 'Ampliar foto ' + (i + 1)); });
    }
    $$('[data-bsb-slide] img', g).forEach(function (img) {
      var slide = img.closest('[data-bsb-slide]');
      slide.setAttribute('role', 'button'); slide.setAttribute('tabindex', '0');
      slide.style.cursor = 'zoom-in';
      slide.addEventListener('click', function () { open(imgs.indexOf(img)); });
      slide.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(imgs.indexOf(img)); } });
    });
    label();
    // Galeria reordenada pela cor: o visualizador passa a seguir a nova ordem.
    g.addEventListener('bsb:reorder', function () {
      imgs = visible(); total = imgs.length;
      label();
      if (dlg) { if (dlg.open) dlg.close(); dlg.remove(); dlg = null; }
    });
  }

  function initBuy(root) {
    if (root.__bsb) return; root.__bsb = true;
    var src = document.getElementById(root.getAttribute('data-bs-data'));
    var data = null;
    try { data = src ? JSON.parse(src.textContent) : null; } catch (e) { data = null; }
    var config = $('[data-bsb-config]', root);

    // Parcela sem "com juros" (só neste template; o motor bs-buy é compartilhado).
    var buy = root.__bsBuy;
    if (buy && !buy.__bsbInst) {
      var inst = buy.installment;
      buy.installment = function (cents, suffix) { return inst.call(this, cents, suffix).replace(' com juros', ''); };
      buy.__bsbInst = true;
      buy.update(true);
    }
    var cards = $$('[data-bs-offer-card]', root);

    // Parcelas por cartão (mesma conta do motor: tabela Price com a taxa do metacampo).
    if (data && data.offers) {
      var n = data.installments || 0, r = data.rate || 0;
      data.offers.forEach(function (o) {
        var v = o.variants.filter(function (x) { return x.a; })[0] || o.variants[0];
        if (!v || !n) return;
        var pmt = r > 0 ? v.p * r * Math.pow(1 + r, n) / (Math.pow(1 + r, n) - 1) : v.p / n;
        $$('[data-bsb-inst="' + o.key + '"]', root).forEach(function (el) {
          el.textContent = 'ou ' + n + 'x de ' + money(Math.round(pmt)) + (r > 0 ? ' no cartão' : ' sem juros');
        });
      });
      // Esconde o cartão de uma oferta que não veio nos dados (produto indisponível).
      var keys = data.offers.map(function (o) { return o.key; });
      $$('[data-bsb-offer]', root).forEach(function (w) {
        if (keys.indexOf(w.getAttribute('data-bsb-offer')) === -1) w.hidden = true;
      });
    }

    function place(key, keepCard) {
      var wrap = $('[data-bsb-offer="' + key + '"]', root);
      if (!wrap || !config) return;
      var panel = $('[data-bsb-panel]', wrap);
      $$('[data-bsb-offer]', root).forEach(function (w) { w.classList.toggle('is-open', w === wrap); });
      cards.forEach(function (c) { c.setAttribute('tabindex', c.getAttribute('data-bs-offer-card') === key ? '0' : '-1'); });
      if (panel.contains(config)) return;
      var before = keepCard ? keepCard.getBoundingClientRect().top : null;
      panel.appendChild(config);
      if (keepCard) {
        var delta = keepCard.getBoundingClientRect().top - before;
        if (Math.abs(delta) > 1) window.scrollBy(0, delta);
      }
    }

    root.addEventListener('bs:change', function (e) {
      var key = e.detail && e.detail.offer;
      if (key) place(key, $('[data-bs-offer-card="' + key + '"]', root));
    });
    var active = $('[data-bs-offer-card].is-active', root);
    if (active) place(active.getAttribute('data-bs-offer-card'));

    // Setas do teclado entre os cartões (padrão de radiogroup).
    cards.forEach(function (c, i) {
      c.addEventListener('keydown', function (e) {
        var d = (e.key === 'ArrowDown' || e.key === 'ArrowRight') ? 1 : (e.key === 'ArrowUp' || e.key === 'ArrowLeft') ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        var visible = cards.filter(function (x) { return !x.closest('[hidden]'); });
        var j = (visible.indexOf(c) + d + visible.length) % visible.length;
        visible[j].click(); visible[j].focus();
      });
    });

    // Cor escolhida na oferta de 1 peça (seção: color_photos): a galeria abre com as fotos da cor. A cor que abre
    // marcada volta à ordem original da galeria, a não ser que tenha linha própria em color_photos.
    var gal = $('[data-bsb-gallery]', root.closest('.bsb-main') || document);
    var byColor = colorPhotos(gal);
    if (byColor) {
      var initial = buy && buy.sel ? buy.sel.color : null, shown = initial;
      root.addEventListener('bs:change', function (e) {
        var d = e.detail || {};
        var color = d.selection && d.selection.color;
        if (d.offer !== 'single' || !color || color === shown) return;
        if (shown === null) { initial = shown = color; return; }
        shown = color;
        var list = byColor[color.toLowerCase()] || [];
        if (gal.__bsbOrder) gal.__bsbOrder(color === initial && !list.own ? [] : list);
      });
    }

    // Sem fotos por cor configuradas: galeria volta para a 1ª foto quando a cor muda na oferta de 1 peça.
    var lastColor = null;
    root.addEventListener('bs:change', function (e) {
      var d = e.detail || {};
      var color = d.selection && d.selection.color;
      if (!byColor && d.offer === 'single' && color && lastColor && color !== lastColor) {
        var g = $('[data-bsb-gallery]');
        if (g && g.__bsbGo) g.__bsbGo(0);
      }
      lastColor = color;
    });

    // Fotos das peças da oferta seguem a cor (seção: color_items). No kit, "Preto + Off White" dá uma cor por peça.
    var itemsBox = $('[data-bsb-color-items]', root);
    if (itemsBox) {
      var pics = {};
      try { pics = JSON.parse(itemsBox.getAttribute('data-bsb-color-items')) || {}; } catch (e) { pics = {}; }
      var paint = function (offer, color) {
        if (!offer || !color) return;
        var parts = color.split(/\s*\+\s*/);
        $$('[data-bsb-offer="' + offer + '"] [data-bsb-item]', root).forEach(function (li) {
          var name = parts.length > 1 ? parts[+li.getAttribute('data-bsb-item')] : color;
          var u = name && pics[name.trim().toLowerCase()], img = $('img', li);
          if (!u || !img || img.getAttribute('src') === u) return;
          img.removeAttribute('srcset');
          img.src = u;
        });
      };
      root.addEventListener('bs:change', function (e) {
        var d = e.detail || {};
        paint(d.offer, d.selection && d.selection.color);
      });
      if (buy && buy.sel) paint(buy.offerKey, buy.sel.color);
    }

  }

  /* ---------- Guia de tamanho (manequim → tamanho) ---------- */
  function initFit(dlg) {
    if (dlg.__bsb) return; dlg.__bsb = true;
    var out = $('[data-bsb-fit-out]', dlg), res = $('[data-bsb-fit-result]', dlg), use = $('[data-bsb-fit-use]', dlg);
    var chosen = null;
    $$('[data-bsb-fit-size]', dlg).forEach(function (b) {
      b.addEventListener('click', function () {
        chosen = b.getAttribute('data-bsb-fit-size');
        $$('[data-bsb-fit-size]', dlg).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        $$('[data-bsb-row]', dlg).forEach(function (tr) { tr.classList.toggle('is-hit', tr.getAttribute('data-bsb-row') === chosen); });
        if (out) out.textContent = chosen;
        if (res) res.hidden = false;
      });
    });
    if (use) use.addEventListener('click', function () {
      if (!chosen) return;
      var root = document.querySelector('[data-bs-size-guide="' + dlg.id + '"]');
      var btn = root && root.querySelector('.bs-opt--size .bs-opt__value[data-value="' + chosen + '"]');
      dlg.close();
      if (btn) { btn.click(); btn.focus({ preventScroll: false }); }
    });
  }

  /* ---------- Trilhos horizontais ---------- */
  function initRail(rail) {
    if (rail.__bsb) return; rail.__bsb = true;
    var track = $('[data-bsb-rail-track]', rail), prev = $('[data-bsb-rail-prev]', rail), next = $('[data-bsb-rail-next]', rail);
    if (!track) return;
    function step() { var it = track.children[0]; return it ? it.getBoundingClientRect().width + 12 : 300; }
    function sync() {
      var max = track.scrollWidth - track.clientWidth;
      rail.classList.toggle('is-static', max < 4);
      if (prev) prev.disabled = track.scrollLeft < 4;
      if (next) next.disabled = track.scrollLeft > max - 4;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduced ? 'auto' : 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduced ? 'auto' : 'smooth' }); });
    track.addEventListener('scroll', function () { requestAnimationFrame(sync); }, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  /* ---------- Vídeos (tocam só ao toque) ---------- */
  function initVideos() {
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-bsb-video-toggle]');
      var frame = t ? t.closest('[data-bsb-video]') : e.target.closest('[data-bsb-video]');
      if (!frame) return;
      var v = $('video', frame), li = frame.parentNode;
      if (!v) return;
      if (v.paused) {
        $$('[data-bsb-video] video').forEach(function (o) { if (o !== v && !o.paused) { o.pause(); o.parentNode.parentNode.classList.remove('is-playing'); } });
        v.controls = true;
        var p = v.play(); if (p && p.catch) p.catch(function () {});
        li.classList.add('is-playing');
        var b = $('[data-bsb-video-toggle]', frame); if (b) b.setAttribute('aria-label', 'Pausar vídeo');
      } else if (t) {
        v.pause(); li.classList.remove('is-playing');
      }
    });
    document.addEventListener('pause', function (e) {
      if (e.target.tagName === 'VIDEO' && e.target.closest('[data-bsb-video]')) {
        var li = e.target.closest('[data-bsb-video]').parentNode;
        li.classList.remove('is-playing');
        var b = $('[data-bsb-video-toggle]', li); if (b) b.setAttribute('aria-label', 'Tocar vídeo');
      }
    }, true);
  }

  /* ---------- Links "voltar para a compra" ---------- */
  function initScrollBuy() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-bsb-scroll-buy]');
      if (!a) return;
      var target = $('.bsb-offers') || $('#bsb-buy');
      if (!target) return;
      e.preventDefault();
      scrollToEl(target);
    });
  }

  /* Bolinha de 2 cores sem serrilhado: o bs-buy.js (compartilhado) desenha a divisória com corte seco em 50%;
     aqui a transição ganha ~1px de degradê. Só nas páginas bs-blumi. */
  function smoothSwatches(box) {
    var fix = function () {
      box.querySelectorAll('.bs-opt__value--swatch').forEach(function (btn) {
        var v = btn.style.getPropertyValue('--bs-swatch');
        if (v && v.indexOf(' 0 50%, ') > -1) {
          btn.style.setProperty('--bs-swatch', v.replace(' 0 50%, ', ' 0 calc(50% - .6px), ').replace(' 50% 100%)', ' calc(50% + .6px) 100%)'));
        }
      });
    };
    fix();
    new MutationObserver(fix).observe(box, { childList: true, subtree: true });
  }

  var booted = false;
  function boot() {
    $$('.bsb-info [data-bs-options]').forEach(function (box) {
      if (box.hasAttribute('data-bsb-smooth')) return;
      box.setAttribute('data-bsb-smooth', '');
      smoothSwatches(box);
    });
    $$('[data-bsb-gallery]').forEach(function (g) { initGallery(g); initLightbox(g); });
    $$('.bsb-info[data-bs-buy]').forEach(initBuy);
    $$('dialog.bsb-dialog').forEach(initFit);
    $$('[data-bsb-rail]').forEach(initRail);
    if (!booted) { initVideos(); initScrollBuy(); booted = true; }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

/* Seletor de quantidade (− 1 +) ao lado do botão, quando a seção liga show_qty. */
document.addEventListener('click', function (e) {
  var b = e.target.closest && e.target.closest('[data-bsb-qty-step]');
  if (!b) return;
  var input = b.closest('[data-bsb-qty]').querySelector('[data-bs-qty]');
  var n = (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-bsb-qty-step'), 10);
  input.value = Math.min(10, Math.max(1, n));
});
document.addEventListener('change', function (e) {
  if (!e.target.matches || !e.target.matches('[data-bs-qty]')) return;
  e.target.value = Math.min(10, Math.max(1, parseInt(e.target.value, 10) || 1));
});
